import { motion } from "framer-motion";
import { INDUSTRIES } from "@/lib/site";
import { Reveal } from "./Reveal";

export const Industries = () => {
  return (
    <section id="industries" data-testid="industries" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-brand mb-4">07 — Industries We Serve</p>
          <h2 className="font-display font-extrabold text-navy tracking-tight text-4xl md:text-5xl max-w-2xl leading-[1.05]">
            Funding growth across sectors.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {INDUSTRIES.map((ind, i) => (
            <motion.div
              key={ind.label}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 6) * 0.06 }}
              data-testid={`industry-${i}`}
              className="group aspect-square grid place-content-center gap-3 text-center rounded-2xl bg-surface border border-black/5 hover:bg-navy transition-colors duration-300 cursor-default"
            >
              <ind.icon className="w-7 h-7 mx-auto text-brand group-hover:text-emerald transition-colors" />
              <span className="text-sm font-semibold text-navy group-hover:text-white transition-colors">{ind.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
